<template>
  <settings-menu-layout>
    <user-list></user-list>
  </settings-menu-layout>
</template>

<script>
  import LoadSettingsMixin from "@/mixins/LoadSettingsMixin";
  import SettingsMenuLayout from "@/components/layout/SettingsMenuLayout";
  import UserList from "@/components/UserList";
  export default {
    name: "SettingsUsers",
    mixins: [LoadSettingsMixin],
    data() {
      return {
      }
    },
    methods: {
      set_loading(loading) {
        this.loading = loading
      },
      select_item(page) {
        this.selected_page = page
      },
    },
    components: {
      UserList,
      SettingsMenuLayout},
    mounted() {
    },
  }
</script>

<style scoped>

</style>